export default (props, e) => {
  let hash = window.location.hash.substring(1);
  if (hash !== 'back-to-list') {
    e.preventDefault();
    window.history.back();
  }
};



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/webActions/goBackEnhanced.js